import type { ChatEventMetric } from "@/sdk/agent/chat/reportChatEvent";

/** Fixed set, so the `outcome` label stays bounded in Mimir. */
export type ChatSpellCheckOutcome = "success" | "suggestions" | "no_result" | "error";

/** What the expert did with the suggestions they were shown. */
export type ChatSpellCheckSuggestionOutcome = "shown" | "sent_with_changes" | "cancelled";

type ChatSpellCheckMetricInput =
    | { eventName: "chat_spellcheck_check"; outcome: ChatSpellCheckOutcome; partner: string | undefined }
    | {
          eventName: "chat_spellcheck_suggestion";
          outcome: ChatSpellCheckSuggestionOutcome;
          partner: string | undefined;
      };

/**
 * Counter for one spellcheck event, landing in Mimir as `exwo_Event_total{eventName, outcome, partner}`.
 *
 * - `chat_spellcheck_check`: completed runs by outcome (aborted or superseded runs are not counted).
 * - `chat_spellcheck_suggestion`: suggestions shown, then sent with changes or cancelled.
 *
 * `checkType` is not a label: the `/metrics` collector silently drops dimension keys outside its allowlist.
 */
export function chatSpellCheckMetric({ eventName, outcome, partner }: ChatSpellCheckMetricInput): ChatEventMetric {
    return {
        metrics: [{ name: "Event", value: 1 }],
        dimensions: { eventName, outcome, partner: partner || "unknown" },
    };
}
